import productAPI from  '../api/product'


//获取产品配置
export const setProductNameSate = ({commit}) => {
  productAPI.getProductConfig({'test':111}).then(res =>{

    if(res && res.appProductNameShow &&  res.appProductNameShow =='ON'){
      commit('SET_PRODUCTNAMESTATE',true)
    }else{
      commit('SET_PRODUCTNAMESTATE',false)
    }

    if(res && res.userCreditQuota && res.userCreditQuota ==1){ //额度开关 0不启用，1：启用
      commit('SET_AVAILABLElIMITSTATE',true)
    }else{
      commit('SET_AVAILABLElIMITSTATE',false)
    }
  })
}

//获取产品配置--COOKIE
export const setProductNameSateFromCookid = ({commit}) => {

   var appProductNameShow = JSON.parse(localStorage.getItem('appProductNameShow'))
   var userCreditQuota = JSON.parse(localStorage.getItem('userCreditQuota'))
   var loginResData = JSON.parse(localStorage.getItem('loginResData'));  // TOk

  // debugger;
  if(appProductNameShow && appProductNameShow =='ON'){
    commit('SET_PRODUCTNAMESTATE',true)
  }else{
    commit('SET_PRODUCTNAMESTATE',false)
  }

  if(userCreditQuota ==1){ //额度开关 0不启用，1：启用
    commit('SET_AVAILABLElIMITSTATE',true)
  }else{
    commit('SET_AVAILABLElIMITSTATE',false)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js